module.exports = __webpack_public_path__ + "static/media/click1.7a7930a2.wav";